import { Button, Modal, ProgressBar } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { selectTranslations, selectDownloadData } from 'redux/selector'
import DCAImage from 'components/DCAImage'
import images from 'assets/images/images'
import 'styles/modal/downloadModal.scss'

export type DownloadModalProps = {
  showModal: boolean
  handleHide: () => void
}

const DownloadModal = ({ showModal, handleHide }: DownloadModalProps) => {
  const translations = useSelector(selectTranslations)
  const downloadData = useSelector(selectDownloadData)

  const downloadStartTxt = translations?.download_starts_now ?? 'DOWNLOAD STARTS NOW'
  const programmeTxt = translations?.programme ?? 'Programme'
  // const stopTxt = translations?.stop ?? 'Stop'
  const okTxt = translations?.ok ?? 'Ok'

  // TODO stop download
  // const onStopDownload = () => {
  //   handleHide()
  // }

  return (
    <Modal show={showModal} onHide={handleHide} size='sm' className='download-modal'>
      <Modal.Header closeButton>
        <Modal.Title className='download-modal-heading'>
          {downloadStartTxt.toUpperCase()}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className='ak-bold my-2'>
          {programmeTxt.toUpperCase()} <DCAImage alt='loader' src={images.loaderDots} />
        </div>

        {Object.entries(downloadData).map(([key, value]) => {
          return (
            <div key={key}>
              <div className='ak-bold'>{key}</div>
              <ProgressBar
                now={value.progress}
                className='progress-bar-container'
                label={`${Math.round(value.progress)}%`}
              />
            </div>
          )
        })}
      </Modal.Body>

      <Modal.Footer>
        <div className='modal-buttons p-3'>
          {/* TODO will enable it later when we done with the MVP */}
          {/* <Button variant='secondary' className='text-uppercase' onClick={onStopDownload}>
            {stopTxt}
          </Button> */}
          <Button variant='primary' className='text-uppercase' onClick={handleHide}>
            {okTxt}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default DownloadModal
